import React, { useState, useEffect, useCallback } from 'react';

import useToast from 'hooks/useToast';
import { PaymentCardData } from 'models/paymentCard';
import PaymentCardSelect from 'screens/components/Payment/PaymentCardSelection';
import { getAllPaymentCards } from 'services/paymentMethodService';

interface Params {
  cardSelected: PaymentCardData;
  showCardSelection?: boolean;
}

const PaymentCardSelectionContainer = ({ cardSelected, showCardSelection }: Params) => {
  const [cardList, setCardList] = useState<PaymentCardData[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const getCardList = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getAllPaymentCards();
      setIsLoading(false);
      setCardList(response);
    } catch (error) {
      toast.add({
        type: 'danger',
        message: error.message,
      });
      setIsLoading(false);
    }
  }, [toast]);

  useEffect(() => {
    getCardList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PaymentCardSelect
      cardList={cardList}
      isLoading={isLoading}
      onUpdate={() => {
        getCardList();
      }}
    />
  );
};

export default PaymentCardSelectionContainer;
